import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ink text-cream mt-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-6">— 2026</p>
            <h2 className="font-heading text-5xl md:text-7xl leading-[0.95] tracking-tight">
              <span className="italic text-peach">Scrivimi.</span>
            </h2>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-4">Naviga</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="editorial-link">About</Link></li>
              <li><Link to="/progetti" className="editorial-link">Progetti</Link></li>
              <li><Link to="/competenze" className="editorial-link">Competenze</Link></li>
              <li><Link to="/libro" className="editorial-link">Il Libro</Link></li>
              <li><Link to="/contatti" className="editorial-link">Contatti</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-4">Contatti</p>
            <ul className="space-y-3 text-sm">
              <li><a href="mailto:giovanni.gabban@gmail.com" className="editorial-link">giovanni.gabban@gmail.com</a></li>
              <li><a href="https://www.linkedin.com/in/giovannigabban/" target="_blank" rel="noreferrer" className="editorial-link">LinkedIn</a></li>
              <li><Link to="/admin" className="text-cream/40 hover:text-peach text-xs">Area riservata</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/40">
          <span>© 2026 Giovanni Gabban — Brand Strategist & Content Architect</span>
          <span>
            Realizzato con cura editoriale ·{" "}
            <Link to="/privacy-policy" className="editorial-link hover:text-peach">
              GDPR
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
